import { cloneDeep } from "lodash";
import { isNonEmptyString, isNonEmptyObject } from "@cayuse/shared-react.utils.type-checks";

import { picklists as constants } from "store/constants";
import { PICKLIST_TYPE } from "globals/constants";


const picklistState = {
	isFetching: false,
	hasError: false,
	options: [],
};

const initialState = {
	[PICKLIST_TYPE?.ORGANIZATIONS]: { ...picklistState },
	[PICKLIST_TYPE?.RESEARCH_TEAM_ROLES]: { ...picklistState },
	[PICKLIST_TYPE?.UNITS]: { ...picklistState },
	[PICKLIST_TYPE?.AD_HOC_TEAMS]: { ...picklistState },
};

export const picklists = (incomingState = initialState, action) => {
	const picklistId = action.picklistId;
	let state = cloneDeep(incomingState);

	if (isNonEmptyString(picklistId) && !isNonEmptyObject(state[picklistId])) {
		state[picklistId] = { ...picklistState };
	}

	switch (action.type) {
		case constants.IS_FETCHING:
			return {
				...state,
				[picklistId]: {
					...state[picklistId],
					isFetching: action.isFetching,
				},
			};
		case constants.SET_ERROR:
			return {
				...state,
				[picklistId]: {
					...state[picklistId],
					hasError: action.hasError,
				},
			};
		case constants.SET_OPTIONS:
			return {
				...state,
				[picklistId]: {
					...state[picklistId],
					options: [
						...action.options,
					],
				},
			};
		default:
			return state;
	}
};
